import React, { useEffect, useState } from 'react';

import { 
    Card,
    CardBody
} from 'reactstrap';

import FullSpinner from 'components/Common/FullSpinner';
import PageBase from 'components/Common/PageBase';
import Filters from './Filters';
import HeaderReport from './HeaderReport';
import TableReport from './TableReport';

import useRequest from 'hooks/useRequest';

import '../../../../assets/scss/reports/daily-movements.scss';
import { getAccountingAcounts } from 'store/accounting-accounts/actions';
import { useDispatch } from 'react-redux';
import { getClientsBalanceReport } from '../../../../helpers/backend_helper';
import { initialPeriod } from 'static';

const breadcrumbList = [
    { id: '1', title: 'Administrativo', active: false },
    { id: '2', title: 'Reportes', active: false },
    { id: '3', title: 'Concentrado de ventas', active: true }
];

export default function BalanceClientContainer() {

    const dispatch = useDispatch();
    const [ period, setPeriod ] = useState(initialPeriod);
    const [ columnOrder, setColumnOrder ] = useState({
        column: '',
        order: ''
    });

    const {
        data,
        isLoading,
        req
    } = useRequest();

    const handleFilters = (params) => {
        const config = {
            params,
        };
        req(getClientsBalanceReport(config));
    }

    useEffect(() => {        
        dispatch(getAccountingAcounts());
    }, []);
    
    return (
        <>  
            { isLoading && <FullSpinner /> }
            <PageBase
                titleMeta="Reporte de saldos clientes"
                titleBread="Reporte de saldos clientes"
                itemsBread={ breadcrumbList }
            >
                <Card>
                    <CardBody>
                        <Filters
                            data={ data }
                            handleFilters={ handleFilters }
                            setPeriod={ setPeriod }
                            columnOrder={ columnOrder }
                        />
                    </CardBody>
                </Card>                
                <Card>
                    <CardBody>                  
                        { data && data.report.length  ? (
                            <>
                                <HeaderReport period={ period }/>
                                <TableReport 
                                    data={ data.report } 
                                    totals={ data.totals }
                                    setColumnOrder={ setColumnOrder }
                                    columnOrder={ columnOrder }
                                />
                            </>
                        ) : <p>No hay datos con el periodo seleccionado</p>}
                    </CardBody>
                </Card>
            </PageBase>
        </>
    );
}